import { TextEntryFilterOption } from '../types';
import { CSVTextEntry } from '../../components';

export const config: TextEntryFilterOption = {
  id: 'omicsExplorer.filters.proteinChanges',
  title: {
    id: 'omicsExplorer.filters.proteinChanges',
    defaultMessage: 'Protein Changes',
  },
  content: CSVTextEntry,
  injectedProps: {
    searchKey: 'aminoAcidChange',
    textEntryOption: {
      id: 'omicsExplorer.filters.proteinChanges',
      searchValue: '',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.proteinChanges.placeholderLabel',
        defaultMessage: 'Add (comma-separated)',
      },
    },
  },
};
